let deviceInfo = {
    /**
     * @description 获取系统信息
     */
    getOSInfo() {
        let userAgent = window.navigator.userAgent.toLowerCase()
        let version = "";
        let digits = "";
        if (userAgent.indexOf("win") > -1) {
            if (userAgent.indexOf("windows nt 5.0") > -1 || userAgent.indexOf("Windows 2000") > -1) {
                version = "Windows 2000";
            } else if (userAgent.indexOf("windows nt 5.1") > -1 || userAgent.indexOf("Windows XP") > -1) {
                version = "Windows XP";
            } else if (userAgent.indexOf("windows nt 5.2") > -1 || userAgent.indexOf("Windows 2003") > -1) {
                version = "Windows 2003";
            } else if (userAgent.indexOf("windows nt 6.0") > -1 || userAgent.indexOf("Windows Vista") > -1) {
                version = "Windows Vista";
            } else if (userAgent.indexOf("windows nt 6.1") > -1 || userAgent.indexOf("windows 7") > -1) {
                version = "Windows 7";
            } else if (userAgent.indexOf("windows nt 6.2") > -1 || userAgent.indexOf("windows 8") > -1) {
                version = "Windows 8";
            } else if (userAgent.indexOf("windows nt 6.3") > -1) {
                version = "Windows 8.1";
            } else if (userAgent.indexOf("windows nt 6.4") > -1 || userAgent.indexOf("windows nt 10") > -1) {
                version = "Windows 10";
            } else {
                version = "Unknown";
            }
        } else if (userAgent.indexOf("iphone") > -1) {
            version = "Iphone";
        } else if (userAgent.indexOf("mac") > -1) {
            version = "Mac";
        } else if (userAgent.indexOf("x11") > -1 || userAgent.indexOf("unix") > -1 || userAgent.indexOf("sunname") > -1 || userAgent.indexOf("bsd") > -1) {
            version = "Unix";
        } else if (userAgent.indexOf("linux") > -1) {
            if (userAgent.indexOf("android") > -1) {
                version = "Android"
            } else {
                version = "Linux";
            }
        } else {
            version = "Unknown";
        }
        // 系统位数
        var is64 = userAgent.indexOf("win64") > -1 || userAgent.indexOf("wow64") > -1;
        if (is64) {
            digits = "64位";
        } else {
            digits = "32位";
        }

        return {
            version: version,
            digits: digits
        };
    },

    /**
     * @description 获取浏览器信息
     */
    getBrowser() {
        let rMsie = /(msie\s|trident\/7)([\w\.]+)/;
        let rTrident = /(trident)\/([\w.]+)/;
        let rEdge = /(chrome)\/([\w.]+)/; //IE

        let rFirefox = /(firefox)\/([\w.]+)/; //火狐
        let rOpera = /(opera).+version\/([\w.]+)/; //旧Opera
        let rNewOpera = /(opr)\/(.+)/; //新Opera 基于谷歌
        let rChrome = /(chrome)\/([\w.]+)/; //谷歌 
        let rUC = /(chrome)\/([\w.]+)/; //UC
        let rMaxthon = /(chrome)\/([\w.]+)/; //遨游
        let r2345 = /(chrome)\/([\w.]+)/; //2345
        let rQQ = /(chrome)\/([\w.]+)/; //QQ
        //var rMetasr =  /(metasr)\/([\w.]+)/;//搜狗
        let rSafari = /version\/([\w.]+).*(safari)/;

        let ua = navigator.userAgent.toLowerCase();
        let matchBS;
        let browser = {
            name: "",
            version: ""
        };
        //IE 低版
        matchBS = rMsie.exec(ua);

        if (matchBS != null) {
            let matchBS2 = rTrident.exec(ua);
            if (matchBS2 != null) {
                switch (matchBS2[2]) {
                    case "4.0":
                        return {
                            browser:
                                "Microsoft IE",
                                version: "IE: 8" //内核版本号
                        };
                        break;
                    case "5.0":
                        return {
                            browser:
                                "Microsoft IE",
                                version: "IE: 9"
                        };
                        break;
                    case "6.0":
                        return {
                            browser:
                                "Microsoft IE",
                                version: "IE: 10"
                        };
                        break;
                    case "7.0":
                        return {
                            browser:
                                "Microsoft IE",
                                version: "IE: 11"
                        };
                        break;
                    default:
                        return {
                            browser:
                                "Microsoft IE",
                                version: "Undefined"
                        };
                }
            } else {
                browser.name = "Microsoft IE";
                browser.version = "IE:" + matchBS[2] || "0";
            }
        }
        //IE最新版
        matchBS = rEdge.exec(ua);
        if ((matchBS != null) && (!(window.attachEvent))) {
            browser.name = "Microsoft Edge";
            browser.version = "Chrome/" + matchBS[2] || "0";
        }
        //UC浏览器					  
        matchBS = rUC.exec(ua);
        if ((matchBS != null) && (!(window.attachEvent))) {
            browser.name = "UC";
            browser.version = "Chrome/" + matchBS[2] || "0";
        }
        //火狐浏览器
        matchBS = rFirefox.exec(ua);
        if ((matchBS != null) && (!(window.attachEvent))) {
            browser.name = "火狐";
            browser.version = "Firefox/" + matchBS[2] || "0";
        }
        //Oper浏览器					 
        matchBS = rOpera.exec(ua);
        if ((matchBS != null) && (!(window.attachEvent))) {
            browser.name = "Opera";
            browser.version = "Chrome/" + matchBS[2] || "0";
        }
        //遨游
        matchBS = rMaxthon.exec(ua);
        if ((matchBS != null) && (!(window.attachEvent))) {
            browser.name = "遨游";
            browser.version = "Chrome/" + matchBS[2] || "0";
        }
        //2345浏览器					  
        matchBS = r2345.exec(ua);
        if ((matchBS != null) && (!(window.attachEvent))) {
            browser.name = "2345";
            browser.version = "Chrome/ " + matchBS[2] || "0";
        }
        //QQ浏览器					  
        matchBS = rQQ.exec(ua);
        if ((matchBS != null) && (!(window.attachEvent))) {
            browser.name = "QQ";
            browser.version = "Chrome/" + matchBS[2] || "0";
        }
        //Safari（苹果）浏览器
        matchBS = rSafari.exec(ua);
        if ((matchBS != null) && (!(window.attachEvent)) && (!(window.chrome)) && (!(window.opera))) {
            browser.name = "Safari";
            browser.version = "Safari/" + matchBS[1] || "0";
        }
        //谷歌浏览器
        matchBS = rChrome.exec(ua);
        if ((matchBS != null) && (!(window.attachEvent))) {
            let matchBS2 = rNewOpera.exec(ua);
            if (matchBS2 == null) {
                browser.name = "谷歌";
                browser.version = "Chrome/" + matchBS[2] || "0";
            } else {
                browser.name = "Opera";
                browser.version = "opr/" + matchBS2[2] || "0";
            }
        }
        return browser;
    }
};

export default {
    os: deviceInfo.getOSInfo(),
    browser: deviceInfo.getBrowser()
}